<div id="{{position}}" class="position-relative"
    [ngStyle]="{ 'background-color': backgroundColor,'background-image': backgroundColor.includes('#')?'none':backgroundColor }">
    <div class="global-max-width" *ngIf="!loading">
        <div class="content-carousel"
            [ngStyle]="{ 'background-color': backgroundColor,'background-image': backgroundColor.includes('#')?'none':backgroundColor }">
            <div class="title app-header-headline" [attr.data-aos]="textAnimation ? textAnimation : null"
                data-aos-duration="1100">
                <h1 class="blog-title" [ngClass]="[titleSize]"
                    [ngStyle]="{ 'font-family': titleFontFamily ? titleFontFamilyName : '' ,'color': titleColor?titleColor:textColor,'font-weight': fontWeight }">
                    {{ title }}</h1>
                <p *ngIf="subTitle" class="sub-title center blog-subtitle" [ngStyle]="{ 'color': textColor }">
                    {{subTitle}}</p>
            </div>
            <div class="carousel">
                <div class="soon" *ngIf="!(articles$ | async) || (articles$ | async).length <= 0"
                    [ngStyle]="{ 'color': textColor }">We'll be
                    adding new posts soon. Stay tuned!</div>
                <mat-card [ngClass]="shadowEffect?'mat-card-box-shadow':''" [ngStyle]="{'border-radius': borderRadius+'px'}" *ngFor="let post of (articles$ | async) as articles"
                    [attr.data-aos]="itemsAnimation ? itemsAnimation : null" data-aos-duration="1500">
                    <a [routerLink]="['/blog/' + post.category + '/' + post.linkTitle +'/'+ post.createdAt]"
                        [attr.aria-label]="post.linkTitle">
                        <div class="blog-image-container" [ngStyle]="{'background-image':'url('+post.coverImage+');' }">
                        </div>
                    </a>
                    <mat-card-content>
                        <div class="blog-text-container">
                            <span *ngIf="displayCategory" class="dateCategory">
                                <span>{{post.category}}</span>
                            </span>
                            <span *ngIf="!displayCategory" class="dateCategory">
                                <span>{{post.createdAt | date:'MMM d, y'}}</span>
                            </span>
                            <!-- <p>{{post.category}}</p> -->
                            <h2   [ngStyle]="{'margin-bottom':!displayDescription?'25px':'0px' }" class="m-0"><a
                                    [routerLink]="['/blog/' + post.category + '/' + post.linkTitle +'/'+ post.createdAt]">{{post.title}}</a>
                            </h2>
                        </div>
                        <div *ngIf="displayDescription" class="post-content" [innerHTML]="post.article | safeHtml"></div>
                        <div *ngIf="displayCategory" class="post-meta-data">
                            <div>{{post.createdAt | date:'MMM d, y'}} . {{post.readTime ? post.readTime + ' read':''}}
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
            </div>
            <div *ngIf="displayLoadMore" style="text-align: center;margin-top: 30px;">
                <button [routerLink]="['/blog/articles']"
                    style="cursor: pointer; display: inline-block; width: 150px; padding: 5px;cursor: pointer"
                    class="app-button mat-raised-button" mat-raised-button rel="noopener">
                    <span class="mat-button-wrapper">
                        See More
                        <mat-icon style="vertical-align: text-top;">keyboard_arrow_right</mat-icon>
                    </span>
                </button>
            </div>
        </div>
    </div>
</div>